let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7PEF4")).then(() => parcelRequire('5MBZ1'));